module.exports = __webpack_public_path__ + "media/assets/images/blog/contact_flow_example-samm-4c02d11be313c92a8a0c57c472d11d70.png";